import {
  ESTADO_PEDIDO_CANCELADO,
  ESTADO_PEDIDO_INCIDENCIA,
} from './../../shared/constants';
import * as Constantes from '../../shared/constants';

import { OnDestroy } from '@angular/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';

//Modelos e Interfaces
import { ICliente } from 'src/app/interfaces/cliente';
import { IListaOpciones } from 'src/app/interfaces/lista-opciones';

// Servicios
import { ArticulosService } from 'src/app/services/datos/articulos.service';
import { ClientesService } from 'src/app/services/datos/clientes.service';

// Librerias
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import { ITraza } from 'src/app/interfaces/traza';
import { PedidosService } from 'src/app/services/datos/pedidos.service';
import { IArticulo } from 'src/app/interfaces/articulo';
import FuncLib from 'src/app/providers/funcionesLib';

@Component({
  selector: 'app-traza-lista',
  templateUrl: './traza-lista.component.html',
  styleUrls: ['./traza-lista.component.scss'],
})
export class TrazaListaComponent implements OnInit, OnDestroy {

  // Librería de funciones
  public funcLib: FuncLib = new FuncLib();

  // Usar constantes en el template
  Constantes = Constantes;

  loading: boolean = false;
  public fotoDir: string = environment.fotoDir;

  textoDestacado: string = '';
  public strBuscarTodo: string = '';

  messages = {
    emptyMessage: `<span class="text-danger">Sin datos...</span>`,
    totalMessage: 'Total',
    selectedMessage: 'seleccionado',
  };

  trazaList: ITraza[] = [];
  clientesList: ICliente[] = [];
  articulosList: IArticulo[] = [];

  rows: ITraza[] = [];
  temp: any[] = [];

  columns = [];
  ColumnMode = ColumnMode;

  opcionesList: IListaOpciones = {};
  public clienteSeleccionadoId: number = 0;
  public articuloSeleccionadoId: number = 0;

  public rowsLimitStr: string = localStorage.getItem('linTablas') || '10';
  public rowsLimit: number = parseInt(this.rowsLimitStr);

  public imgResized: string = localStorage.getItem('imgResized') || '/resize/';
  public summaryPosition: string =
    localStorage.getItem('summaryPosition') || 'bottom';

  imagenSeleccionada: string | null = null;

  @ViewChild(TrazaListaComponent) table: TrazaListaComponent | any;

  constructor(
    public articulosSrv: ArticulosService,
    public pedidosSrv: PedidosService,
    private clientesSrv: ClientesService
  ) { }

  ngOnDestroy(): void { }

  ngOnInit(): void {
    this.getClientesList();
    //  this.getArticulosList();
    this.getTrazaLotes();
  }

  // Devulve la lista filtrada de pedidos repartidos con artículos que se han servidos con LOTES
  getTrazaLotes() {
    this.opcionesList = {};
    if (this.clienteSeleccionadoId > 0)
      this.opcionesList.id_cliente = this.clienteSeleccionadoId;
    if (this.articuloSeleccionadoId > 0)
      this.opcionesList.id_articulo = this.articuloSeleccionadoId;
    this.opcionesList.swLote = '1';

    this.loading = true;
    this.pedidosSrv.listTrazaLotes(this.opcionesList).subscribe((resp) => {
      this.loading = false;

      console.log('__getTrazaLotes() opcionesList', this.opcionesList);
      console.log('__getTrazaLotes() resp', resp);

      this.trazaList = resp.data;
      this.rows = this.trazaList;
      this.temp = [...this.trazaList];
    });
  }

  getClientesList() {
    this.loading = true;
    this.clientesSrv.getLista().subscribe((resp) => {
      this.loading = false;
      this.clientesList = resp.data.filter(
        (cliente: { archivado: boolean }) => !cliente.archivado
      );
    });
  }

  // Get lista de artículos del cliente seleccionado que getionen lotes
  getArticulosList() {
    this.opcionesList = {};
    this.opcionesList.id_cliente = this.clienteSeleccionadoId;
    this.opcionesList.swLote = '1';
    this.loading = true;
    this.articulosSrv.getListaFiltrada(this.opcionesList).subscribe((resp) => {
      this.loading = false;
      this.articulosList = resp.data;
      console.log('__getArticulosList() opcionesList', this.opcionesList);
      console.log('__getArticulosList() resp', resp);
    });
  }

  // Búscar y filtrar

  filtro(val: string, campo: string) {
    // filter our data
    const temp = this.temp.filter(function (d) {
      if (d[campo]) return d[campo].toLowerCase().indexOf(val) !== -1 || !val;
      return !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.trazaList;
  }

  buscar(event: any, campo: string) {
    const txt = event?.target?.value?.toLowerCase() ?? '';
    this.filtro(txt, campo);
  }

  buscarTodo(event: any) {
    const txt = event?.target?.value?.toLowerCase() ?? '';
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some(
        (key: any) =>
          d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );

    // Marcar el texto destacado
    this.textoDestacado = txt;

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.trazaList;
  }

  dblclickCampo(valor: any) {
    this.strBuscarTodo = String(valor);
    const txt = valor.toLowerCase() ?? '';
    this.buscaGlobal(txt);
  }

  buscaGlobal(txt: string) {
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some(
        (key: any) =>
          d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );

    // Marcar el texto destacado
    this.textoDestacado = txt;

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.trazaList;
  }

  limpiaBusca() {
    this.strBuscarTodo = '';
    this.buscaGlobal('');
    const buscaTodoInput = document.getElementById('buscaTodo');
    buscaTodoInput?.focus();
  }

  rowsLimitChange() {
    this.rowsLimit = parseInt(this.rowsLimitStr);
  }

  // Filtros

  onClienteSelect() {
    console.log(
      '__onClienteSelect() clienteSeleccionadoId',
      this.clienteSeleccionadoId
    );
    this.opcionesList = {};
    this.opcionesList.id_cliente = this.clienteSeleccionadoId;
    this.getArticulosList();
    this.getTrazaLotes();
  }

  onArticuloSelect() {
    //this.opcionesList.id_articulo = this.articuloSeleccionadoId;
    console.log(
      '__onArticuloSelect() articuloSeleccionadoId',
      this.articuloSeleccionadoId
    );
    this.getTrazaLotes();
  }

  // AUX  //

  public sumaCeldas(cells: any[]) {
    // Devuelve la suma de la columna, formateada y sin decimales
    const filteredCells = cells.filter((cell) => !!cell);
    const sum: number = filteredCells.reduce(
      (accumulator, currentValue) => accumulator + parseFloat(currentValue),
      0
    );
    // return sum.toLocaleString('es');
    return sum.toLocaleString('de-DE');
  }

  public cuentaCeldas(cells: any[]) {
    // Devuelve el número de filas
    const filteredCells = cells.filter((cell) => !!cell);
    const sum: number = filteredCells.reduce(
      (accumulator, currentValue) => accumulator + 1,
      0
    );
    return sum.toLocaleString('de-DE');
  }

  // EXPORTAR A EXCEL
  exportToExcel(): void {
    // Create a new array with flattened data structure

    const transformEstadoToText = (value: string): string => {
      // 1 Pendiente, 3 Servido, 4 Cancelado, 5 Servido parcialmente, 8 Incidencia
      switch (value) {
        case Constantes.ESTADO_PEDIDO_PENDIENTE:
          return 'Pendiente';
        case Constantes.ESTADO_PEDIDO_SERVIDO:
          return 'Servido';
        case Constantes.ESTADO_PEDIDO_CANCELADO:
          return 'Cancelado';
        case Constantes.ESTADO_PEDIDO_SERVIDO_PARCIALMENTE:
          return 'Servido con faltas';
        case Constantes.ESTADO_PEDIDO_INCIDENCIA:
          return 'Incidencia';
        default:
          return value as string;
      }
    };

    const flattenedRows = this.rows.map((row) => {
      return {
        // Cliente
        Cliente: row.cliente?.nombre,
        Contacto: row.cliente?.contacto,
        'eMail cliente': row.cliente?.email,

        // Pedido
        'Id pedido': row.pedido?.id,
        'Nº Pedido': row.pedido?.pedido_cli,
        'Tipo Pedido': row.pedido?.tipoPedido,
        Estado: transformEstadoToText(row.pedido?.estado ?? ''),

        'Fecha estado': row.pedido?.estado_at,
        'Ubicación de origen': row.ubicacion,
        'Uic utilizado': row.uic,

        // Artículo
        'Id articulo': row.id_articulo,
        Cantidad: row.cant_repartida,
        Lote: row.lote,

        SKU: row.articulo?.sku,
        EAN: row.articulo?.ean,
        Descripción: row.articulo?.descripcion,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(flattenedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, 'trazabilidad_lotes.xlsx');
  }

  // Modal imágen
  abrirPopupImagen(url: string) {
    console.log('__abrirPopupImagen()', url);
    if (url.includes('_noFoto')) return;
    this.imagenSeleccionada = url;
  }

  cerrarPopupImagen() {
    this.imagenSeleccionada = null;
  }
}
